export default __webpack_public_path__ + "book_details-publication_date.588c870b.png";